// Mock data for Sea Spice Kitchen - Coastal Fusion Restaurant

export const restaurantInfo = {
  name: "Sea Spice Kitchen",
  tagline: "Where Coastal Freshness Meets Global Flavour",
  shortDesc: "Frankston's Home of Coastal Fusion Dining",
  address: {
    line1: "1/432 Nepean Highway",
    line2: "Frankston VIC 3199",
    country: "Australia"
  },
  phone: "+61 3 7057 2373",
  phoneDisplay: "(03) 7057 2373",
  email: "info@seaspicekitchen.com.au",
  hours: {
    weekdays: "6:30 AM – 11:30 PM",
    weekends: "6:30 AM – 11:30 PM",
    closed: "Seven Days Open"
  },
  socials: {
    instagram: "@seaspicekitchen",
    facebook: "seaspicekitchen"
  }
};

export const heroImages = [
  "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-2_2880x2304.jpg",
  "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-3_2880x2304.jpg"
];

export const menuHighlights = [
  {
    id: 1,
    category: "Mains From The Sea",
    name: "Sizzling Garlic King Prawns",
    description: "Sizzling king prawns cooked in a rich garlic butter sauce, finished with white wine, chilli and herbs. Served with steamed rice and lemon.",
    price: "$36.50",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicPrawns_2880x2304.jpg",
    signature: true
  },
  {
    id: 2,
    category: "Mains From The Sea",
    name: "Barramundi al Miele",
    description: "Grilled barramundi served with golden chips, fresh garden salad and our signature honey mustard sauce.",
    price: "$34.00",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Barramundi_2880x2304.jpg",
    signature: true
  },
  {
    id: 3,
    category: "New Additions",
    name: "Garlic Butter Tiger Prawns",
    description: "Premium Queensland tiger prawns grilled in garlic herb butter with fresh lemon, parsley and cracked pepper. Served with fries and garden salad.",
    price: "$36.60",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicButterTigerPrawns_2880x2304.jpg",
    signature: true
  },
  {
    id: 4,
    category: "Steakhouse Style",
    name: "Slow-Cooked BBQ Pork Ribs",
    description: "Slow-cooked pork ribs glazed with BBQ sauce, served with chips and salad.",
    price: "$35.00",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SlowCookedBBQRibs_2880x2304.jpg",
    signature: true
  },
  {
    id: 5,
    category: "Steakhouse Style",
    name: "Maiale Croccante (Crispy Pork Belly)",
    description: "Pork belly pieces, crispy crackling, sticky spicy sauce, rosemary and sage vegetables and seasonal greens.",
    price: "$32.00",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_MaialeCroccante_2880x2304.jpg"
  },
  {
    id: 6,
    category: "Mains From The Sea",
    name: "Smoked BBQ Bacon Oysters",
    description: "Fresh South Australian oysters topped with crispy smoked bacon, house-made smoky BBQ glaze and spring onions.",
    price: "6 pc $22.60 / 12 pc $39.60",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Oysters_2880x2304.jpg",
    isNew: true
  },
  {
    id: 7,
    category: "Mains From The Sea",
    name: "Salt & Pepper Calamari",
    description: "Semolina dusted and flash fried, served with chips, salad, garlic aioli and lemon.",
    price: "$29.50",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Salt&PepperCalamari_2880x2304.jpg"
  },
  {
    id: 8,
    category: "Mains From The Sea",
    name: "Bourbon Glazed Salmon",
    description: "Served on silky cauliflower puree with crispy skin and juicy prawns.",
    price: "$37.60",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_BourbonGlazedSalmon_2880x2304.jpg"
  },
  {
    id: 9,
    category: "Burgers",
    name: "Southern Fried Chicken Burger",
    description: "Southern fried chicken, American cheese, chef special sauce with honey glazed bacon, brioche bun and chips.",
    price: "$25.00",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SouthernFriedChickenBurger_2880x2304.jpg"
  },
  {
    id: 10,
    category: "Sweet Breakfast",
    name: "Fluffy Buttermilk Pancakes",
    description: "Seasonal fruit, mixed berry compote, maple syrup, powdered sugar and vanilla ice cream.",
    price: "$24.00",
    image: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_FluffyButterPancakes_2880x2304.jpg"
  }
];
export const fullMenu = {
  "BREAKFAST & FAMILY FOOD": {
    "Breakfast Classics": [
      {
        "name": "Big Breakfast",
        "description": "2 eggs your way, chorizo, mushroom, bacon, spinach, roast tomato, halloumi and sourdough.",
        "price": "$25.80"
      },
      {
        "name": "Egg & Bacon Roll",
        "description": "Fried egg, crispy bacon, cheese and maple bourbon BBQ sauce on a brioche bun.",
        "price": "$12.00"
      },
      {
        "name": "Bacon Egg Halloumi Bagel",
        "description": "Crispy bacon, fried egg and grilled halloumi with house romesco sauce on a toasted bagel.",
        "price": "$14.00"
      },
      {
        "name": "Sausage Egg & Romesco Roll",
        "description": "Sausage, fried egg and romesco sauce on a ciabatta roll.",
        "price": "$14.00"
      },
      {
        "name": "Eggs Your Way",
        "description": "2 eggs poached, fried or scrambled, served with sourdough toast.",
        "price": "$15.50"
      },
      {
        "name": "Avocado Toast",
        "description": "2 poached eggs, smashed avocado, sourdough bread, fresh tomato and dukkah.",
        "price": "$21.80"
      },
      {
        "name": "Eggs Benedict on Butter Croissant",
        "description": "Two perfectly poached eggs served on a warm butter croissant with silky house-made hollandaise sauce and fresh herbs.",
        "price": "$18.60",
        "signature": true
      },
      {
        "name": "Chilli Scrambled Eggs",
        "description": "Creamy scrambled eggs with fresh chilli, spring onions and herbs, served on toasted sourdough with a drizzle of chilli oil.",
        "price": "$17.80",
        "signature": true
      }
    ],
    "Light Bites": [
      {
        "name": "Ham & Cheese Toastie",
        "description": "",
        "price": "$7.00"
      },
      {
        "name": "Ham, Cheese & Tomato Toastie",
        "description": "",
        "price": "$7.50"
      },
      {
        "name": "Ham & Cheese Croissant",
        "description": "",
        "price": "$7.00"
      },
      {
        "name": "Chicken Wrap",
        "description": "Grilled chicken, lettuce, tomato, cheese and aioli wrapped in a soft tortilla.",
        "price": "$10.00"
      },
      {
        "name": "Falafel Wrap",
        "description": "Falafel, hummus, lettuce, tomato, onion, cucumber and tahini sauce in a wrap.",
        "price": "$9.00"
      }
    ],
    "Sweet Breakfast": [
      {
        "name": "Golden Waffles",
        "description": "Crispy buttermilk fried chicken, tangy bacon and drizzled maple syrup.",
        "price": "$24.00"
      },
      {
        "name": "Berry Brioche French Toast",
        "description": "Vanilla cinnamon custard brioche, mixed compote and whipped cream.",
        "price": "$24.00"
      },
      {
        "name": "Fluffy Buttermilk Pancakes",
        "description": "Seasonal fruit, mixed berry compote, maple syrup, powdered sugar and vanilla ice cream.",
        "price": "$24.00"
      }
    ],
    "Kids Menu": [
      {
        "name": "Nuggets & Chips",
        "description": "",
        "price": "$12.00"
      },
      {
        "name": "Fish & Chips",
        "description": "",
        "price": "$12.00"
      },
      {
        "name": "Linguine Bolognese",
        "description": "",
        "price": "$12.00"
      },
      {
        "name": "Schnitzel & Chips",
        "description": "",
        "price": "$14.00"
      },
      {
        "name": "Calamari & Chips",
        "description": "",
        "price": "$14.00"
      },
      {
        "name": "Parma & Chips",
        "description": "",
        "price": "$14.00"
      },
      {
        "name": "Eggs Your Way",
        "description": "",
        "price": "$8.00"
      },
      {
        "name": "Kids Waffles",
        "description": "",
        "price": "$12.00"
      },
      {
        "name": "Kids Fresh Toast",
        "description": "",
        "price": "$12.00"
      },
      {
        "name": "Kids Pancake",
        "description": "",
        "price": "$12.00"
      }
    ],
    "Breakfast Add-ons": [
      {
        "name": "Extra Egg",
        "description": "",
        "price": "$3.00"
      },
      {
        "name": "Hash Brown",
        "description": "",
        "price": "$4.00"
      },
      {
        "name": "Bacon",
        "description": "",
        "price": "$5.00"
      },
      {
        "name": "Halloumi",
        "description": "",
        "price": "$5.00"
      },
      {
        "name": "Ham",
        "description": "",
        "price": "$3.00"
      },
      {
        "name": "Smoked Salmon",
        "description": "",
        "price": "$6.00"
      }
    ],
    "Sweet Indulgence": [
      {
        "name": "Sticky Toffee Date",
        "description": "Warm sticky date pudding smothered in rich toffee sauce and topped with creamy vanilla ice cream.",
        "price": "$12.99"
      }
    ]
  },
  "APPETISERS & MAINS FROM THE SEA": {
    "Appetisers": [
      {
        "name": "Chicken Wings",
        "description": "Choose your style: Garlic Parmesan or Korean.",
        "price": "6 pc $16.00 · Full $32.00"
      },
      {
        "name": "Pane all’Aglio · Garlic Bread (4)",
        "description": "Artisan bread, garlic, balsamic cream and Tuscan olive oil.",
        "price": "$7.00"
      },
      {
        "name": "Pane all’Aglio e Formaggio · Cheesy Garlic Bread (4)",
        "description": "Artisan bread topped with mozzarella cheese.",
        "price": "$8.00"
      },
      {
        "name": "Chilli Cheesy Bread (4)",
        "description": "Artisan bread, mozzarella cheese and chilli.",
        "price": "$8.00"
      },
      {
        "name": "Chilli Bacon Bread (4)",
        "description": "Artisan bread topped with mozzarella cheese, crispy bacon and sweet chilli.",
        "price": "$9.60",
        "new": true
      },
      {
        "name": "Sizzling Prawns with Turkish Bread",
        "description": "Six sizzling prawns served with warm Turkish bread.",
        "price": "$17.00"
      },
      {
        "name": "Salt & Pepper Calamari (6 pc)",
        "description": "Semolina dusted, flash fried, served with chips, salad, garlic aioli and lemon.",
        "price": "$15.50"
      },
      {
        "name": "Southern Fried Prawns",
        "description": "Crispy fried prawns served with chipotle sauce.",
        "price": "$13.65"
      }
    ],
    "Soup": [
      {
        "name": "Seafood Chowder",
        "description": "Creamy seafood chowder with prawns, fish and mussels, served with sourdough bread.",
        "price": "$18.60"
      }
    ],
    "Mains From The Sea": [
      {
        "name": "Barramundi al Miele",
        "description": "Grilled barramundi served with golden chips, fresh garden salad and our signature honey mustard sauce.",
        "price": "$34.00",
        "glutenFree": true
      },
      {
        "name": "Sizzling Garlic King Prawns",
        "description": "Sizzling king prawns cooked in a rich garlic butter sauce, finished with white wine, chilli and herbs. Served with steamed rice and lemon.",
        "price": "$36.50",
        "signature": true
      },
      {
        "name": "Salt & Pepper Calamari (12 pc)",
        "description": "Semolina dusted, flash fried, served with chips, salad, garlic aioli and lemon.",
        "price": "$29.50"
      },
      {
        "name": "Smoked BBQ Bacon Oysters",
        "description": "Fresh South Australian oysters topped with crispy smoked bacon, house-made smoky BBQ glaze and spring onions. Flame-grilled for a rich, smoky, sweet and savoury finish.",
        "price": "6 pc $22.60 · 12 pc $39.60",
        "new": true
      },
      {
        "name": "Bourbon Glazed Salmon",
        "description": "On cauliflower puree, silky smooth, crispy skin and juicy prawns.",
        "price": "$37.60"
      }
    ]
  },
  "BURGERS, GRILL & HERITAGE": {
    "Burgers": [
      {
        "name": "Southern Fried Chicken Burger",
        "description": "Southern fried chicken, American cheese, chef special sauce with honey glazed bacon, brioche bun and chips.",
        "price": "$25.00"
      },
      {
        "name": "Jalapeno Popper Burger",
        "description": "Double smashed beef patty with jalapeños, maple bacon, double American cheese and homemade bacon sweet sauce on a brioche bun with chips.",
        "price": "$25.00"
      }
    ],
    "Steakhouse Style": [
      {
        "name": "Slow-Cooked BBQ Pork Ribs",
        "description": "Slow-cooked pork ribs glazed with BBQ sauce, served with chips and salad.",
        "price": "$35.00"
      },
      {
        "name": "Maiale Croccante (Crispy Pork Belly)",
        "description": "Pork belly pieces, crispy crackling, sticky spicy sauce, rosemary and sage vegetables, seasonal greens.",
        "price": "$32.00"
      }
    ],
    "Bread & Rice": [
      {
        "name": "Plain Naan",
        "description": "",
        "price": "$5.90"
      },
      {
        "name": "Garlic Naan",
        "description": "",
        "price": "$5.90"
      },
      {
        "name": "Basmati Rice",
        "description": "",
        "price": "$5.90"
      }
    ],
    "Heritage Flavours": [
      {
        "name": "Butter Chicken",
        "description": "Tender chicken simmered in creamy tomato, butter, cashew and fenugreek sauce. Served with steamed rice or naan.",
        "price": "$26.00"
      },
      {
        "name": "Lamb Rogan Josh",
        "description": "Boneless lamb in rich tomato, onion and aromatic spice sauce. Served with steamed rice or naan.",
        "price": "$27.00"
      },
      {
        "name": "Beef Vindaloo",
        "description": "Tender beef cooked in a tangy chilli, vinegar, garlic and cumin spice sauce. Served with steamed rice or naan.",
        "price": "$26.00"
      }
    ],
    "Sides": [
      {
        "name": "Chips",
        "description": "",
        "price": "$7.00"
      },
      {
        "name": "Garlic Aioli",
        "description": "",
        "price": "$2.00"
      },
      {
        "name": "Creamy Garlic Prawn Sauce",
        "description": "",
        "price": "$7.00"
      },
      {
        "name": "Baconnaise",
        "description": "",
        "price": "$3.00"
      },
      {
        "name": "Side Salad",
        "description": "",
        "price": "$6.00"
      },
      {
        "name": "Garlic Herb Potatoes",
        "description": "",
        "price": "$8.00"
      },
      {
        "name": "Steamed Greens",
        "description": "",
        "price": "$6.00"
      },
      {
        "name": "Gravy",
        "description": "",
        "price": "$3.00"
      }
    ]
  },
  "PASTAS & SCHNITZELS": {
    "Pastas": [
      {
        "name": "Bolognese",
        "description": "Rich Napoli sauce with minced beef, finished with parsley and Parmesan.",
        "price": "$22.00"
      },
      {
        "name": "La Pasta Meravigliosa (Super Bowl)",
        "description": "Garlic, bacon, chicken, basil, white wine, mushrooms, Kalamata olives, pine nuts, sun-dried tomatoes, cream and pasta.",
        "price": "$25.00"
      },
      {
        "name": "Seafood Linguine",
        "description": "Prawns, scallops and calamari tossed with linguine in garlic seafood sauce.",
        "price": "$34.50"
      },
      {
        "name": "Carbonara con Pollo",
        "description": "Rigatoni, chicken, bacon and creamy sauce.",
        "price": "$22.00"
      },
      {
        "name": "Boscaiola Classica",
        "description": "Rigatoni, bacon, mushrooms and creamy sauce.",
        "price": "$22.00"
      }
    ],
    "New Additions": [
      {
        "name": "Chicken Scallopini",
        "description": "Chicken scallopini with garlic herb potatoes, char-grilled broccolini and creamy mushroom and bacon sauce.",
        "price": "$28.00"
      },
      {
        "name": "Garlic Butter Tiger Prawns",
        "description": "Premium Queensland tiger prawns grilled in garlic herb butter with fresh lemon, parsley and cracked pepper. Served with fries and garden salad.",
        "price": "$36.60"
      }
    ],
    "Schnitzels & Toppings": [
      {
        "name": "Homemade Schnitzel (Plain)",
        "description": "Crumbed chicken schnitzel served with your choice of sides.",
        "price": "$22.00"
      },
      {
        "name": "Parmy",
        "description": "Fresh tomato sauce, bacon and mozzarella.",
        "price": "$24.00"
      },
      {
        "name": "Sea Spice Kitchen",
        "description": "Bacon and shallots in a creamy white sauce, topped with mozzarella.",
        "price": "$27.00"
      },
      {
        "name": "Hawaiian",
        "description": "Bacon, pineapple and mozzarella.",
        "price": "$26.00"
      },
      {
        "name": "Aussie",
        "description": "BBQ sauce, bacon, salami, mozzarella, battered onion rings and fried egg.",
        "price": "$27.00"
      }
    ]
  },
  "BEVERAGES": {
    "Hot Beverages": [
      {
        "name": "Cappuccino",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Latte",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Flat White",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Mocha",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Chai Latte",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Dirty Chai",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Hot Chocolate",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Long Black",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Matcha Latte",
        "description": "Regular / Large",
        "price": "$5.00 / $5.50"
      },
      {
        "name": "Short Macchiato",
        "description": "Regular",
        "price": "$4.50"
      },
      {
        "name": "Long Macchiato",
        "description": "Large",
        "price": "$5.00"
      }
    ],
    "Extras & Alternative Milks": [
      {
        "name": "Extra Shot",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Soy Milk",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Almond Milk",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Oat Milk",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Lactose Free Milk",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Skim Milk",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Hazelnut Syrup",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Vanilla Syrup",
        "description": "",
        "price": "$1.00"
      },
      {
        "name": "Caramel Syrup",
        "description": "",
        "price": "$1.00"
      }
    ],
    "Iced Drinks": [
      {
        "name": "Iced Coffee",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Long Black",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Latte",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Matcha",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Chai",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Chocolate",
        "description": "",
        "price": "$10.20"
      },
      {
        "name": "Iced Mocha",
        "description": "",
        "price": "$10.20"
      }
    ],
    "Tea Pots": [
      {
        "name": "English Breakfast",
        "description": "",
        "price": "$6.50"
      },
      {
        "name": "Earl Grey",
        "description": "",
        "price": "$6.50"
      },
      {
        "name": "Green Tea",
        "description": "",
        "price": "$6.50"
      },
      {
        "name": "Lemon & Ginger Tea",
        "description": "",
        "price": "$6.50"
      }
    ],
    "Milkshakes": [
      {
        "name": "Chocolate Milkshake",
        "description": "",
        "price": "$9.50"
      },
      {
        "name": "Vanilla Milkshake",
        "description": "",
        "price": "$9.50"
      },
      {
        "name": "Strawberry Milkshake",
        "description": "",
        "price": "$9.50"
      },
      {
        "name": "Caramel Milkshake",
        "description": "",
        "price": "$9.50"
      },
      {
        "name": "Banana Milkshake",
        "description": "",
        "price": "$9.50"
      }
    ]
  }
};
export const drinksMenu = {
  "COCKTAILS & REFRESHMENTS": {
    "Signature Cocktails": [
      { name: "Espresso Martini", price: 18.50 },
      { name: "Aperol Spritz", price: 16.50 },
      { name: "Mojito", price: 16.50 },
      { name: "Margarita", price: 17.50 },
      { name: "Negroni", price: 18.50 },
      { name: "Old Fashioned", price: 18.50 },
      { name: "Cosmopolitan", price: 17.50 },
      { name: "Pornstar Martini", price: 18.50 }
    ],

    "Beer & Cider": [
      { name: "Victoria Bitter (VB)", price: 8.00 },
      { name: "Coopers Original Pale Ale", price: 9.00 },
      { name: "Carlton Draught", price: 9.00 },
      { name: "Corona", price: 10.00 },
      { name: "Asahi Super Dry", price: 10.00 },
      { name: "Heineken Original", price: 10.00 },
      { name: "Peroni Nastro Azzurro", price: 10.00 },
      { name: "Balter XPA", price: 11.00 },
      { name: "Stone & Wood Pacific Ale", price: 11.00 },
      { name: "Summersby Apple Cider", price: 11.00 }
    ],

    "Mocktails": [
      { name: "Shirley Temple", price: 10.00 },
      { name: "Cucumber Mint Fizz", price: 10.00 },
      { name: "Tropical Sunrise", price: 10.00 },
      { name: "Lemon Lime Bitters", price: 8.00 },
      { name: "Virgin Mojito", price: 11.00 },
      { name: "Passionfruit Spritz", price: 11.00 },
      { name: "Virgin Pina Colada", price: 12.00 }
    ],

    "Juices & Soft Drinks": [
      { name: "Apple Juice", price: 5.00 },
      { name: "Orange Juice", price: 5.00 },
      { name: "Cranberry Juice", price: 5.00 },
      { name: "Pineapple Juice", price: 5.00 },
      { name: "Soda Water", price: 4.00 },
      { name: "Tonic Water", price: 4.00 },
      { name: "Lemonade", price: 5.00 },
      { name: "Dry Ginger Ale", price: 5.00 },
      { name: "Coke", price: 5.00 },
      { name: "Coke Zero", price: 5.00 },
      { name: "Sprite", price: 5.00 },
      { name: "Solo", price: 5.00 }
    ]
  },

  "APERITIFS & SPIRITS": {
    "Aperitifs & Liqueurs · 30ml": [
      { name: "Aperol", price: 10.00 },
      { name: "Campari", price: 10.00 },
      { name: "Martini Rosso Vermouth", price: 9.00 },
      { name: "Cinzano Rosso", price: 9.00 },
      { name: "Lillet Aperitif", price: 10.00 },
      { name: "Kahlua", price: 10.00 },
      { name: "Cointreau", price: 10.00 },
      { name: "Disaronno Amaretto", price: 10.00 },
      { name: "Midori", price: 10.00 },
      { name: "Baileys", price: 10.00 },
      { name: "Frangelico", price: 10.00 },
      { name: "Malibu", price: 10.00 },
      { name: "Chambord", price: 10.00 }
    ],

    "Vodka · 30ml": [
      { name: "Smirnoff", price: 9.00 },
      { name: "Absolut", price: 10.00 },
      { name: "Belvedere", price: 13.00 },
      { name: "Ciroc", price: 12.00 },
      { name: "Grey Goose", price: 13.00 }
    ],

    "Gin · 30ml": [
      { name: "Gordon's", price: 9.00 },
      { name: "Bombay Sapphire", price: 11.00 },
      { name: "Tanqueray", price: 11.00 },
      { name: "Hendrick's", price: 12.00 },
      { name: "Four Pillars", price: 12.00 }
    ],

    "Rum · 30ml": [
      { name: "Bacardi White", price: 9.00 },
      { name: "Captain Morgan", price: 9.00 },
      { name: "Bundaberg", price: 9.00 }
    ],

    "Tequila · 30ml": [
      { name: "Espolon Blanco", price: 11.00 },
      { name: "Don Julio Blanco", price: 14.00 },
      { name: "Patron Silver", price: 13.00 }
    ],

    "Cognac · 30ml": [
      { name: "Hennessy VS", price: 13.00 },
      { name: "Martell VS", price: 13.00 }
    ]
  },

  "THE WHISKY COLLECTION": {
    "Scotch & Irish": [
      { name: "Johnnie Walker Red", price: 9.00 },
      { name: "Johnnie Walker Black", price: 11.00 },
      { name: "Johnnie Walker Green Label", price: 13.00 },
      { name: "Johnnie Walker Gold Label", price: 16.00 },
      { name: "Chivas Regal", price: 11.00 },
      { name: "Monkey Shoulder", price: 11.00 },
      { name: "Glenfiddich", price: 13.00 },
      { name: "Glenlivet 12", price: 13.00 },
      { name: "Laphroaig 10", price: 14.00 },
      { name: "Jameson", price: 10.00 }
    ],

    "American, Canadian & Australian": [
      { name: "Jack Daniel's", price: 10.00 },
      { name: "Gentleman Jack", price: 11.00 },
      { name: "Jim Beam", price: 9.00 },
      { name: "Buffalo Trace", price: 11.00 },
      { name: "Maker's Mark", price: 11.00 },
      { name: "Canadian Club", price: 9.00 },
      { name: "Archie Rose Rye Whisky", price: 12.00 },
      { name: "The Ned", price: 11.00 },
      { name: "Starward", price: 12.00 }
    ]
  },

  "WINE MENU": {
    "Red Wine": [
      {
        name: "Taylors Cabernet Sauvignon",
        glassPrice: 10.00,
        bottlePrice: 40.00
      },
      {
        name: "Grant Burge Shiraz",
        glassPrice: 11.00,
        bottlePrice: 44.00
      },
      {
        name: "Pepperjack Shiraz",
        glassPrice: 12.00,
        bottlePrice: 48.00
      },
      {
        name: "Barossa Valley Estate Shiraz",
        glassPrice: 11.00,
        bottlePrice: 44.00
      },
      {
        name: "Faith Shiraz",
        glassPrice: 11.00,
        bottlePrice: 44.00
      },
      {
        name: "Rabbit Ranch Pinot Noir",
        glassPrice: 13.00,
        bottlePrice: 52.00
      },
      {
        name: "South Island Pinot Noir",
        glassPrice: 10.00,
        bottlePrice: 40.00
      },
      {
        name: "Bellini Lambrusco",
        glassPrice: 10.00,
        bottlePrice: 38.00
      }
    ],

    "White Wine": [
      {
        name: "Lobster Reef Sauvignon Blanc",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Marlborough Sounds Pinot Gris",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Kim Crawford Sauvignon Blanc",
        glassPrice: 12.00,
        bottlePrice: 48.00
      },
      {
        name: "Shaw & Smith Sauvignon Blanc",
        glassPrice: 13.00,
        bottlePrice: 55.00
      },
      {
        name: "Green Snapper Sauvignon Blanc",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Paul Mas Chardonnay",
        glassPrice: 10.00,
        bottlePrice: 40.00
      },
      {
        name: "Franklin Tate Buttery Chardonnay",
        glassPrice: 11.00,
        bottlePrice: 45.00
      },
      {
        name: "Cat Amongst The Pigeons Pinot Grigio",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Cat Amongst The Pigeons Zero Alcohol Chardonnay",
        glassPrice: 9.00,
        bottlePrice: 34.00
      }
    ],

    "Moscato · Rosé · Sparkling": [
      {
        name: "Brown Brothers Moscato Victoria",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Brown Brothers Moscato Rose",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Little Yering Dry Rose",
        glassPrice: 11.00,
        bottlePrice: 42.00
      },
      {
        name: "Cat Amongst The Pigeons Rose",
        glassPrice: 10.00,
        bottlePrice: 38.00
      },
      {
        name: "Brown Brothers Prosecco",
        glassPrice: 10.00,
        bottlePrice: 40.00
      },
      {
        name: "Chandon Brut NV",
        glassPrice: 13.00,
        bottlePrice: 55.00
      },
      {
        name: "Ovata Rose (Yarra Valley)",
        glassPrice: 11.00,
        bottlePrice: 42.00
      },
      {
        name: "Croser NV",
        glassPrice: 12.00,
        bottlePrice: 50.00
      },
      {
        name: "Moet & Chandon Champagne",
        glassPrice: 21.00,
        bottlePrice: 115.00
      },
      {
        name: "Mumm Cordon Rouge NV · 4 Ans d'Âge",
        glassPrice: 22.00,
        bottlePrice: 120.00
      },
      {
        name: "Mumm Cordon Brut",
        glassPrice: 20.00,
        bottlePrice: 110.00
      }
    ]
  }
};

export const beveragesMenu = {
  "BEVERAGES": {
    "Hot Beverages": [
      { name: "Cappuccino", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Latte", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Flat White", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Mocha", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Chai Latte", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Dirty Chai", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Hot Chocolate", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Long Black", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Matcha Latte", regularPrice: 5.00, largePrice: 5.50 },
      { name: "Short Macchiato", regularPrice: 4.50, largePrice: null },
      { name: "Long Macchiato", regularPrice: null, largePrice: 5.00 }
    ],
    "Extras & Alternative Milks": [
      { name: "Extra shot · Soy milk · Almond milk · Oat milk · Lactose free milk · Skim milk · Hazelnut, Vanilla or Caramel syrup", price: 1.00 }
    ],
    "Iced Drinks": [
      { name: "Iced Coffee", price: 10.20 }, { name: "Iced Long Black", price: 10.20 },
      { name: "Iced Latte", price: 10.20 }, { name: "Iced Matcha", price: 10.20 },
      { name: "Iced Chai", price: 10.20 }, { name: "Iced Chocolate", price: 10.20 },
      { name: "Iced Mocha", price: 10.20 }
    ],
    "Tea Pots": [
      { name: "English Breakfast", price: 6.50 }, { name: "Earl Grey", price: 6.50 },
      { name: "Green Tea", price: 6.50 }, { name: "Lemon & Ginger Tea", price: 6.50 }
    ],
    "Milk Shakes": [
      { name: "Chocolate Milkshake", price: 9.50 }, { name: "Vanilla Milkshake", price: 9.50 },
      { name: "Strawberry Milkshake", price: 9.50 }, { name: "Caramel Milkshake", price: 9.50 },
      { name: "Banana Milkshake", price: 9.50 }
    ]
  }
};

export const galleryImages = [
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_AussiePamar_2880x2304.jpg", caption: "Aussie Parma" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_BaconPamar_2880x2304.jpg", caption: "Bacon Parma" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Barramundi_2880x2304.jpg", caption: "Barramundi" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_BigBreakfast_2880x2304.jpg", caption: "Big Breakfast" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_BourbonGlazedSalmon_2880x2304.jpg", caption: "Bourbon Glazed Salmon" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_ChefSignatureGarlicCrab_2880x2304.jpg", caption: "Chef Signature Garlic Crab" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_ChickenScallopini_2880x2304.jpg", caption: "Chicken Scallopini" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_ChickenWings-1_2880x2304.jpg", caption: "Chicken Wings" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_ChickenWings-2_2880x2304.jpg", caption: "Chicken Wings" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-1_2880x2304.jpg", caption: "Sea Spice Kitchen" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-2_2880x2304.jpg", caption: "Sea Spice Kitchen" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-3_2880x2304.jpg", caption: "Sea Spice Kitchen" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-4_2880x2304.jpg", caption: "Sea Spice Kitchen" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_FluffyButterPancakes_2880x2304.jpg", caption: "Fluffy Buttermilk Pancakes" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_FrenchToast_2880x2304.jpg", caption: "French Toast" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicBread_2880x2304.jpg", caption: "Garlic Bread" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicButterTigerPrawns_2880x2304.jpg", caption: "Garlic Butter Tiger Prawns" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicPrawns_2880x2304.jpg", caption: "Garlic Prawns" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GoldenWaffles_2880x2304.jpg", caption: "Golden Waffles" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_HawaiianPamar_2880x2304.jpg", caption: "Hawaiian Parma" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_LaPastaMeravigliosa_2880x2304.jpg", caption: "La Pasta Meravigliosa" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Lobster_2880x2304.jpg", caption: "Lobster" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_MaialeCroccante_2880x2304.jpg", caption: "Maiale Croccante" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Oysters_2880x2304.jpg", caption: "Oysters" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Salt&PepperCalamari_2880x2304.jpg", caption: "Salt & Pepper Calamari" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SeaSpiceKitchenPamar_2880x2304.jpg", caption: "Sea Spice Kitchen Parma" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SlowCookedBBQRibs_2880x2304.jpg", caption: "Slow-Cooked BBQ Ribs" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SmashedAvo_2880x2304.jpg", caption: "Smashed Avocado" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SmokedBaconOysters_2880x2304.jpg", caption: "Smoked Bacon Oysters" },
  { src: "/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_SouthernFriedChickenBurger_2880x2304.jpg", caption: "Southern Fried Chicken Burger" },
  { src: "/image/siteimages/gallery/restaurantPhotos/Photo%202.png", caption: "Sea Spice Kitchen Dining" },
  { src: "/image/siteimages/gallery/restaurantPhotos/Photo%203.png", caption: "Sea Spice Kitchen Restaurant" },
  { src: "/image/siteimages/gallery/restaurantPhotos/Photo%204.png", caption: "Sea Spice Kitchen Ambience" }
];

export const testimonials = [
  {
    name: "Sarah M.",
    location: "Frankston",
    text: "We came for breakfast and loved the Big Breakfast and coffee. The service was warm, the food was fresh and the kids were very happy with their meals.",
    rating: 5
  },
  {
    name: "Michael T.",
    location: "Mornington Peninsula",
    text: "The sizzling garlic king prawns and Barramundi al Miele were excellent. A great spot for a relaxed dinner, with friendly staff and a lovely atmosphere.",
    rating: 5
  },
  {
    name: "Priya S.",
    location: "Melbourne",
    text: "The butter chicken, fresh naan and heritage flavours were delicious. We finished with cocktails from the bar — Sea Spice Kitchen is perfect for family dinners.",
    rating: 5
  }
];

export const coastalFusionPoints = [
  { title: "Fresh Australian Seafood", desc: "Sourced daily from local Victorian fisheries and prepared with global influences." },
  { title: "Traditional, Reimagined", desc: "Classic recipes elevated with modern techniques and refined presentation." },
  { title: "Authentic Indian Spices", desc: "House-toasted, hand-ground spices balanced with contemporary Australian cuisine." },
  { title: "Mediterranean Freshness", desc: "Bright, herb-forward flavours and simple, ingredient-led cooking." },
  { title: "Seasonal & Local", desc: "Produce sourced from Mornington Peninsula farms whenever possible." },
  { title: "Tradition Meets Innovation", desc: "A dining experience that honours heritage while embracing creativity." }
];
